import { styled } from '@mui/material';
import { colorPalettes } from '../../../../../context/theme';

export const StyledCheckArea = styled.div`
  color: ${({ theme }) =>
    colorPalettes[theme.palette.mode].components.accountSettings.orgsSelector
      .check};
  padding-right: 0.3846rem;
  height: 1.5rem;
  width: 1.5rem;
  position: relative;

  > svg {
    position: absolute;
    right: 0;
    padding: 0.6154rem;
  }
`;
